import { offsetDate } from './timezone';
export const formatPrice = (price) => {
    if (price == null) {
        return '';  
    }

    // Convert the price to a string
    const priceString = price.toString();

    // Calculate the maximum number of digits allowed for the integer and decimal parts
    const totalMaxDigits = 10;

    // Calculate the maximum number of digits for the integer part, prioritizing it
    const maxIntegerDigits = Math.min(totalMaxDigits, priceString.indexOf('.') > -1 ? priceString.indexOf('.') : totalMaxDigits);

    // Calculate the maximum number of digits for the decimal part
    const maxDecimalDigits = totalMaxDigits - maxIntegerDigits;

    // Split the string into parts before and after the decimal point
    const [integerPart, decimalPart] = priceString.split('.');

    // Include all digits from the integer part
    const truncatedInteger = integerPart.slice(0, maxIntegerDigits);

    // If there is a decimal part, include remaining digits from it
    const truncatedDecimal = decimalPart ? decimalPart.slice(0, maxDecimalDigits) : '';

    // Concatenate the truncated integer and decimal parts
    const formattedPrice = truncatedDecimal ? `${truncatedInteger}.${truncatedDecimal}` : truncatedInteger;

    return formattedPrice;
};

export const formatDigitBasePrice = (price, digits = 8) => {
  if (price == null || price === '') {
    return '';
  }
  const n = typeof price === 'string' ? Number(price) : price;
  if (!Number.isFinite(n)) {
    return '';
  }
  return formatFixedTrimmed(n, digits || 8);
};


export const formatPriceUptoDecimals = (price, decimalDigits = 2) => {
    if (price == null) {
        return '';
    }

    const priceString = price.toString();

    const [integerPart, decimalPart] = priceString.split('.');
    let truncatedDecimal = '';
    if (decimalPart) {
        truncatedDecimal = decimalPart.slice(0, decimalDigits);
    }

    const formattedPrice = truncatedDecimal ? `${integerPart}.${truncatedDecimal}` : integerPart;

    return formattedPrice;
};

// Fixed decimals for UI, then trim trailing zeros.
// Examples:
// - 100.00000000 -> "100"
// - 100.23300000 -> "100.233"
// - 0.00009380   -> "0.0000938"
export const formatFixedTrimmed = (value, decimals = 8) => {
  if (value === null || value === undefined || value === '') return '';
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return '';
  if (n === 0) return '0';
  return n.toFixed(decimals).replace(/\.?0+$/, '');
};

export const formatPositionToPipSize = (pipPosition) => {
    if(pipPosition == null){
        return 1;
    }

    return 1 / Math.pow(10, pipPosition);
  }  

export const adjustDateTime = (
  timestamp = '2024-07-03T03:35:11.000Z',
  timeAdjustment = '00:00',
) => {
  return offsetDate(timestamp, timeAdjustment).toISOString();
};

export const formatDate = (timestamp, module = 'Helloworld') => {
  const date = new Date(timestamp);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = +date.getUTCFullYear().toString().slice(2);
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  const formattedDateTime = `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`; 

  return formattedDateTime;
};

export const FILTER_DATE_PLACEHOLDER = 'dd/mm/yy';

/** Short date for compact filter bars — uses local calendar day (not UTC). */
export const formatFilterDate = (timestamp) => {
  if (timestamp == null || timestamp === '') return '';
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2);
  return `${day}/${month}/${year}`;
};

export const formatFilterDateOrPlaceholder = (timestamp) =>
  formatFilterDate(timestamp) || FILTER_DATE_PLACEHOLDER;
export const convertToMilliseconds = (timeString) => {
  let [hours, minutes] = timeString.split(':').map(Number);

  let totalMinutes = hours * 60 + minutes;
  let totalMilliseconds = totalMinutes * 60 * 1000;
  console.log(totalMilliseconds)
  return totalMilliseconds;
};
